import React, { FC, useCallback } from 'react'
import text from 'styles/utility/text.module.scss'
import { BasicCard } from 'components/Card'
import { TextButton } from 'components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { SmallHeadline } from 'components/Typography'
import { State } from 'index'
import { getShoppingBags } from 'reducks/store/selectors'
import { ShoppingBagOptionCard } from './index'
import { ShoppingBagType } from 'types/store'
import { Spacer } from 'components/Utility'
import { switchStoreRef } from 'reducks/auth/operations'
import { db } from 'firebase/index'

type Props = {
  isAdmin?: boolean
  storeId?: string
}

const ShoppingBagCard: FC<Props> = (props) => {
  const { isAdmin, storeId } = props
  const dispatch = useDispatch()

  const shoppingBags: ShoppingBagType[] = useSelector((state: State) => getShoppingBags(state))

  const editShoppingBag = useCallback(() => {
    if (isAdmin && storeId) {
      dispatch(
        switchStoreRef(db.collection('stores').doc(storeId), undefined, undefined, false, '/account/shopping-bag/edit')
      )
    } else {
      dispatch(push('/account/shopping-bag/edit'))
    }
  }, [dispatch, isAdmin, storeId])

  return (
    <BasicCard
      buttonComponent={<TextButton label={'レジ袋オプションを修正'} onClick={editShoppingBag} />}
      title={'現在の設定'}
    >
      {shoppingBags.length > 0 ? (
        <>
          <SmallHeadline label={'価格'} iconPath={'/icon/grey/money.svg'} />
          <Spacer size={8} />
          {shoppingBags.map((shoppingBag) => (
            <ShoppingBagOptionCard shoppingBag={shoppingBag} />
          ))}
        </>
      ) : (
        <p className={`${text.color_grey_02}`}>レジ袋オプションが設定されていません。</p>
      )}
    </BasicCard>
  )
}

export default ShoppingBagCard
